import * as SwitchPrimitive from '@radix-ui/react-switch';
import cn from 'classnames';
import React from 'react';

import {CheckmarkIcon} from '@/components/Icons';

const Switch = ({className, ...props}) => {
    return (
        <SwitchPrimitive.Root
            data-slot='switch'
            className={cn(
                'peer inline-flex h-7 w-12 shrink-0 items-center rounded-full bg-[var(--color-mischka)] p-[2px] outline-none transition-all',
                'focus-visible:ring-ring/50 focus-visible:border-ring focus-visible:ring-[3px]',
                'enabled:cursor-pointer disabled:cursor-not-allowed disabled:opacity-60',
                'data-[state=checked]:bg-tertiary',
                'md:h-8 md:w-14 md:p-[2px]',
                className
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot='switch-thumb'
                className={cn(
                    'pointer-events-none flex aspect-square h-full items-center justify-center rounded-full bg-primary ring-0 transition-transform duration-200',
                    'data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
                    'md:data-[state=checked]:translate-x-6'
                )}
            >
                <CheckmarkIcon />
            </SwitchPrimitive.Thumb>
        </SwitchPrimitive.Root>
    );
};

export default Switch;
